import * as pdfjs from 'pdfjs-dist';

if (typeof window !== 'undefined' && !pdfjs.GlobalWorkerOptions.workerSrc) {
  const publicUrl = process.env.PUBLIC_URL ?? '';
  pdfjs.GlobalWorkerOptions.workerSrc = `${publicUrl}/pdf.worker.min.mjs`;
}

export { pdfjs };
